import * as React from 'react';
import { useSelector } from 'react-redux';
import { specificationsSelector } from '../../selectors';
import { SpecificationColumn, SpecificationItem, Specifications } from '../../components/Specifications';

export const SpecificationsContainer = (): React.JSX.Element => {
  const specifications = useSelector(specificationsSelector);
  const specLen = specifications.length;
  const specMid = Math.ceil(specLen / 2);
  const specificationsColumns = [specifications.slice(0, specMid), specifications.slice(specMid, specLen)];

  return (
    <Specifications>
      <SpecificationColumn>
        {specificationsColumns[0].map((item): React.JSX.Element => {
          return <SpecificationItem key={item.title} title={item.title} value={item.value || '-'} />;
        })}
      </SpecificationColumn>
      <SpecificationColumn>
        {specificationsColumns[1].map((item): React.JSX.Element => {
          return <SpecificationItem key={item.title} title={item.title} value={item.value || '-'} />;
        })}
      </SpecificationColumn>
    </Specifications>
  );
};
